module.exports = __webpack_public_path__ + "img/logo_nav.393b0726.png";